export const MAIN_CLASS_NAME = 'elma365-tool-page';
export const CONTENT_CLASS_NAME = `${MAIN_CLASS_NAME}__content`;
export const TABS_CLASS_NAME = `${CONTENT_CLASS_NAME}__tabs`;
export const FOOTER_CLASSNAME = `${CONTENT_CLASS_NAME}__footer`;
export const MAIN_BUTTONS_CLASSNAME = `${FOOTER_CLASSNAME}__main-buttons`;
export const RESET_BUTTON_CLASSNAME = `${FOOTER_CLASSNAME}__reset-button`;
export const SKELETON_CONTAINER_CLASS_NAME = `${CONTENT_CLASS_NAME}__skeleton-container`;

export const SKELETON_HEIGHT = 32;
export const SKELETON_WIDTH = 384;
